<template>
  <div>
    <el-row :gutter="20">
      <el-col class="integration-settings" :span="20">
        <div>
          <div v-if="integrationWizardIndex >= 1">
            <h4 class="center-text">Guard Duty Configuration Setup</h4>
            <el-steps :active="integrationWizardIndex" :finish-status="apiCall.error? 'error': 'success'">
              <el-step></el-step>
              <el-step></el-step>
            </el-steps>
          </div>
          <el-carousel
            ref="wizard"
            :autoplay="false"
            :loop="false"
            indicator-position="none"
            arrow="never"
            height="400"
          >
            <el-carousel-item :key="1">
              <h3>How to Connect to Guard Duty</h3>
              <p>
                Confluera helps to protect your data, accounts, and workloads from unauthorized access. Confluera data
                protection services provide threat detection that continuously monitors and protects your accounts and
                workload.<span class="text-btn" @click="loadDocumentation('page-partner-signals-amazon-guard-duty')"> Learn More </span>
              </p>

              <el-row type="flex" :gutter="24">
                <el-col :span="4">
                  <el-card shadow="hover" style="text-align: center;">
                    <span class="display-block">
                      <i class="fab fa-aws" style="font-size: 5em;"></i>
                    </span>
                  </el-card>
                </el-col>
                <el-col :span="20">
                  <el-row>
                    <el-row>
                      <el-col :span="1"><span class="bold">Prerequisite</span></el-col>
                      <el-col :span="23"><span class="bold"></span></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="1"><span class="bold hidden">Prerequisite</span></el-col>
                      <el-col :span="23"><li>Customer has already created an S3 bucket to push the results</li></el-col>
                    </el-row>
                  </el-row>
                  <el-row class="mt-20">
                    <el-row>
                      <el-col :span="1"><span class="bold">1/3</span></el-col>
                      <el-col :span="23"><span class="bold">AWS LOGIN</span></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="1"><span class="bold hidden">1/3</span></el-col>
                      <el-col :span="23"><li>Log in to your AWS Account</li></el-col>
                    </el-row>
                  </el-row>
                  <el-row class="mt-20">
                    <el-row>
                      <el-col :span="1"><span class="bold">2/3</span></el-col>
                      <el-col :span="23"><span class="bold">CREATE POLICY</span></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="1"><span class="bold hidden">1/3</span></el-col>
                      <el-col :span="23">Go to IAM console -> Policies</el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="1"><span class="bold hidden">1/3</span></el-col>
                      <el-col :span="23">
                        <span>Download new policy as follows and save (e.g. GuardDutyS3ReadAccessPolicyConfluera)</span>
                        <li>Put bucket name in UI</li>
                        <pre>
{
    "Version": "2012-10-17",
    "Statement": [
        {
            "Sid": "ListObjectsInBucket",
            "Effect": "Allow",
            "Action": [
                "s3:ListBucket"
            ],
            "Resource": [
                "arn:aws:s3:::bucket"
            ]
        },
        {
            "Sid": "AllObjectActions",
            "Effect": "Allow",
            "Action": [
                "s3:GetObject", "s3:DeleteObject"
            ],
            "Resource": [
                "arn:aws:s3:::bucket/*"
            ]
        }    ]
}
                      </pre
                        >
                      </el-col>
                    </el-row>
                  </el-row>
                  <el-row class="mt-20">
                    <el-row>
                      <el-col :span="1"><span class="bold">3/3</span></el-col>
                      <el-col :span="23"><span class="bold">CREATE IAM ROLE</span></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="1"><span class="bold hidden">3/3</span></el-col>
                      <el-col :span="23">
                        <li>Go to IAM console->Roles</li>
                        <li>Create new role</li>
                        <li>Select "Another AWS Account"</li>
                        <li>Put Account# of Confluera <347227527012></li>
                        <li>Select and attach the above created policy</li>
                        <li>Create role (e.g. ConflueraGuardDutyS3AccessRole)</li>
                      </el-col>
                    </el-row>
                  </el-row>
                </el-col>
              </el-row>
            </el-carousel-item>
            <el-carousel-item :key="2">
              <div class="box flex center ">
                <el-form :v-model="integrationWizardForm" label-width="240px" label-position="left" class="full-width">
                  <el-form-item label="Nickname">
                    <el-input
                      v-model="integrationWizardData.nickName"
                      placeholder="Enter a nickname for your integration"
                      @keydown.native.space.prevent
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Role ARN">
                    <el-input v-model="integrationWizardData.roleArn" placeholder="Enter your role ARN"></el-input>
                  </el-form-item>
                  <el-form-item label="Region">
                    <el-input v-model="integrationWizardData.region" placeholder="Enter your Region"></el-input>
                  </el-form-item>
                  <el-form-item label="Bucket Name">
                    <el-input
                      v-model="integrationWizardData.bucket"
                      placeholder="Enter a bucket for your connection"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Prefix Name">
                    <el-input v-model="integrationWizardData.prefix" placeholder="Enter your Prefix"></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="3" class="initiated mt-20">
              <h4 class="center-text">Initiated!</h4>
              <div class="box flex" v-loading="apiCall.outbound" element-loading-spinner="el-icon-loading"></div>
              <div class="box flex mt-20 mb-20">
                <p>
                  Please wait as we are attempting to connect to your Guard Duty account.
                </p>
              </div>
              <div class="box flex mt-20">
                <el-button size="medium" round @click="gotoAlertIntegrationWorkflow">View Configured Account</el-button>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="4" class="initiated error mt-20">
              <h4 class="center-text">Error!</h4>
              <div class="box flex">
                <span class="center-text error-icon">
                  <i class="fas fa-exclamation-triangle"></i>
                </span>
              </div>
              <div class="box mt-20 mb-20 error-message">
                <p>
                  We could not connect to your Guard Duty account.
                </p>
                <p>
                  Troubleshoot to fix your configuration.
                </p>
                <div v-if="apiCall.error" class="box mt-20">
                  <p>
                    {{ apiCall.errorMsg.code }}:
                    {{ apiCall.errorMsg.message }}
                  </p>
                </div>
              </div>
              <div class="box flex mt-40">
                <el-button size="medium" round @click="gotoAlertIntegrationWorkflow">Troubleshoot / FAQs</el-button>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="flex float-right">
            <span
              v-if="integrationWizardIndex >= 1"
              class="text-underline cursor-pointer back-button"
              @click="backIntegrationStep"
            >
              Go Back
            </span>
            <el-button v-if="integrationWizardIndex < 1" size="medium" round @click="nextIntegrationStep">
              Set Up Guard Duty
            </el-button>
            <el-button v-if="integrationWizardIndex == 1" size="medium" round @click="updateIntegrationSettings">
              Submit
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import integrationFormMixin from '@/components/form/integrations/integrationFormMixin'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'

import { GUARDDUTY_SETTINGS_CREATE_REQUEST } from '@/store/modules/integrations/guardduty-settings.type'

export default {
  name: 'GuardDutyIntegrationWorkflow',
  mixins: [integrationFormMixin, loadDocumentationMixin],
  data () {
    return {
      integrationLastStep: 3,
      apiDispatchState: GUARDDUTY_SETTINGS_CREATE_REQUEST
    }
  },
  methods: {},
  created () {},
  computed: {
    ...mapGetters([])
  },
  watch: {},
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/integration_workflow.css';

.verify-details-box {
  border: 2px solid black;
  border-radius: 10px;
  margin-top: 4%;
  padding: 32px;
  height: 80%;
  overflow: auto;
}

.text-btn {
  cursor: pointer;
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/components/form/integrations/GuardDutyIntegrationWorkflow.vue